module.exports = __webpack_public_path__ + "static/media/link.5c9230e7.png";